 var bestCollectionswiper;

      function bestCollectionSwiper() {
        bestCollectionswiper = new Swiper(".fum-best-seller-collection-my-swiper", {
          slidesPerView: "auto",
          spaceBetween: 16,
          centeredSlides: false,
          
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
        on: {
            slideChange: updateNavigationButtons,
          },
        
        });
        updateNavigationButtons()
      }

     function updateNavigationButtons() {
        const prevButtonActive = document.querySelector(".fum-best-seller-collection-swiper-button-prev.active");
        const prevButtonInActive = document.querySelector(".fum-best-seller-collection-swiper-button-prev.inactive");

        const nextButtonActive = document.querySelector(".fum-best-seller-collection-swiper-button-next.active");
        const nextButtonInactive = document.querySelector(".fum-best-seller-collection-swiper-button-next.inactive");

        if (bestCollectionswiper.isBeginning) {
          prevButtonActive.style.display="none";
          prevButtonInActive.style.display="flex";
        } else {
          prevButtonActive.style.display="flex";
          prevButtonInActive.style.display="none";
        }

        if (bestCollectionswiper.isEnd) {
          nextButtonActive.style.display="none";
          nextButtonInactive.style.display="flex";
        } else {
          nextButtonActive.style.display="flex";
          nextButtonInactive.style.display="none";
        }

       const targetId = 'target';
        observeVisibility(targetId, (isVisible) => {
            if (isVisible) {
                 nextButtonActive.style.display="none";
                      nextButtonInactive.style.display="flex";
            } else {
                 nextButtonActive.style.display="flex";
                  nextButtonInactive.style.display="none";
            }
        });
      }

      function slideToIndex(index) {
        bestCollectionswiper.slideToLoop(index);
      }

      function goToNextSlide() {
        bestCollectionswiper.slideNext();
      }

      function goToPrevSlide() {
        bestCollectionswiper.slidePrev();
      }

      function observeVisibility(elementId, callback) {
          const target = document.getElementById(elementId);
      
          if (!target) {
              console.error(`Element with ID ${elementId} not found.`);
              return;
          }
      
          const observer = new IntersectionObserver((entries) => {
              entries.forEach(entry => {
                  callback(entry.isIntersecting);
              });
          });
      
          observer.observe(target);
      }



      document.addEventListener("DOMContentLoaded", () => {
        bestCollectionSwiper();
       
      });
